import invoiceModule from '../module.js'

invoiceModule.directive('saleTaxrateDropdown', ['httpRequest', 'dictService', (httpRequest, dictService) => ({
    scope: {
        goods: '<',
        invoiceType: '<',
        taxChange: '&',
    },
    template: `
        <div class="dropdown">
          <div class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ng-click="queryTaxRateArr()">
            <span ng-show="showTaxRate()" title="{{goods.taxRate}}" class="et-taxrate-dropdown">
                {{goods.taxRate*100+'%'}}
            </span>
            <span class="caret" style="float:left;margin-top: 10px;margin-left:2px"></span>
          </div>
          <ul class="dropdown-menu" ng-show="goods.active" style="min-width: 100px;">
            <li ng-repeat="m in goods.taxRateArrs" ng-class="{active:m==goods.taxRate}" style="text-align: left;padding-left: 5px;">
            <a href="javascript:;" ng-click="selectTaxRate(m)" style="padding-left: 5px;">{{m*100+'%'}}</a> </li>
          </ul>
        </div>
    `,
    replace: true,
    link (scope) {
        function getGoodsInfoTax () {
            const {
                goods,
                invoiceType,
            } = scope
            const rateReq = {
                taxMergeCode: goods.taxMergeCode,
                invType: invoiceType,
                privilegeType: goods.privilegeType ? encodeURIComponent(goods.privilegeType) : '',
            }
            return httpRequest.get_qryGoodsInfoTax(rateReq).then((res) => res.data.value)
        }

        scope.showTaxRate = function showTaxRate () {
            return scope.goods.taxRate || scope.goods.taxRate === 0
        }
        scope.queryTaxRateArr = function queryTaxRateArr () {
            const { goods } = scope
            if (scope.invoiceType != goods.copyInvoiceType) {
                goods.copyInvoiceType = scope.invoiceType
                goods.taxRateLoaded = false
            }
            if (scope.showTaxRate() && !goods.taxRateLoaded) {
                getGoodsInfoTax(goods, scope.invoiceType).then((reteArr) => {
                    goods.taxRateArrs = reteArr
                    goods.taxRateLoaded = true
                    goods.active = true
                })
            } else {
                goods.active = true
            }
        }
        scope.selectTaxRate = function selectTaxRate (taxRate) {
            const { goods } = scope
            goods.$taxRate = taxRate
            scope.taxChange && scope.taxChange(goods)
        }
    },
})])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/saleTaxrateDropdown.js